import authAdminSlice from "./authAdminSlice";
import authTenantSlice from "./authTenantSlice";
import adjustmentOrderSlice from "./adjustmentOrderSlice";
import categorySlice from "./categorySlice";
import customerSlice from "./customerSlice";
import dashboardSlice from "./dashboardSlice";
import inventorySlice from "./inventorySlice";
import planSlice from "./planSlice";
import productSlice from "./productSlice";
import purchaseSlice from "./purchaseSlice";
import salesSlice from "./salesSlice";
import supplierSlice from "./supplierSlice";
import supportRequestSlice from "./supportRequestSlice";
import tenantSlice from "./tenantSlice";
import tenantUserSlice from "./tenantUserSlice";
import transactionSlice from "./transactionSlice";

const rootReducer = {
  authAdmin: authAdminSlice,
  authTenant: authTenantSlice,
  adjustmentOrder: adjustmentOrderSlice,
  category: categorySlice,
  customer: customerSlice,
  dashboard: dashboardSlice,
  inventory: inventorySlice,
  plan: planSlice,
  product: productSlice,
  purchase: purchaseSlice,
  sales: salesSlice,
  supplier: supplierSlice,
  supportRequest: supportRequestSlice,
  tenant: tenantSlice,
  tenantUser: tenantUserSlice,
  transaction: transactionSlice,
};

export default rootReducer;
